// src/hooks/useRateCardSummaries.js
import { useQuery } from "@tanstack/react-query";
import { fetchRateCards } from "../services/rateCards";

export const useRateCard = () =>
  useQuery({
    queryKey: ["rateCard"],
    queryFn: fetchRateCards,
    staleTime: 1000 * 60 * 5, // cache 5m
  });
